<template>
  <IconWrapper v-if="filled" name="calendar" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.6497 2C16.0742 1.99901 16.4099 2.32884 16.4109 2.76862L16.4119 3.51824C19.1665 3.73414 20.9862 5.6112 20.9891 8.48975L21 16.9155C21.0039 20.054 19.0322 21.985 15.8718 21.99L8.15189 22C5.0112 22.004 3.01482 20.027 3.01087 16.8796L3.00001 8.55272C2.99606 5.65517 4.75153 3.78311 7.50618 3.53024L7.50519 2.78061C7.5042 2.34083 7.83002 2.01 8.26445 2.01C8.69887 2.009 9.02469 2.33883 9.02568 2.77861L9.02666 3.47826L14.8914 3.47027L14.8904 2.77062C14.8894 2.33084 15.2152 2.001 15.6497 2ZM16.0525 16.1919H16.0426C15.5884 16.2029 15.2241 16.5837 15.234 17.0435C15.235 17.5032 15.6013 17.882 16.0555 17.892C16.5185 17.891 16.8937 17.5102 16.8927 17.0405C16.8927 16.5707 16.5165 16.1919 16.0525 16.1919ZM7.91691 16.1929C7.46274 16.2129 7.1073 16.5937 7.10828 17.0535C7.12902 17.5132 7.5042 17.8731 7.95837 17.8521C8.40366 17.8321 8.75811 17.4513 8.73738 16.9915C8.7275 16.5417 8.3612 16.1919 7.91691 16.1929ZM11.9847 16.1879C11.5305 16.2089 11.1761 16.5887 11.1761 17.0485C11.1968 17.5082 11.572 17.8671 12.0262 17.8471C12.4705 17.8261 12.8259 17.4463 12.8052 16.9855C12.7953 16.5367 12.429 16.1869 11.9847 16.1879ZM7.91197 12.5947C7.4578 12.6147 7.10335 12.9955 7.10433 13.4553C7.12408 13.915 7.50025 14.2749 7.95442 14.2539C8.39872 14.2339 8.75317 13.8531 8.73244 13.3933C8.72257 12.9435 8.35725 12.5937 7.91197 12.5947ZM11.9807 12.5597C11.5266 12.5797 11.1711 12.9605 11.1721 13.4203C11.1919 13.8801 11.568 14.2389 12.0222 14.2189C12.4665 14.1979 12.821 13.8181 12.8012 13.3583C12.7904 12.9085 12.425 12.5587 11.9807 12.5597ZM16.0485 12.5647C15.5944 12.5747 15.2389 12.9445 15.2399 13.4043V13.4153C15.2498 13.8751 15.625 14.2239 16.0801 14.2139C16.5244 14.2029 16.8789 13.8221 16.869 13.3623C16.8483 12.9225 16.4918 12.5637 16.0485 12.5647ZM14.8934 5.0095L9.02864 5.01749L9.02962 5.82609C9.02962 6.25687 8.70479 6.5967 8.27037 6.5967C7.83595 6.5977 7.50914 6.25887 7.50914 5.82809L7.50815 5.05847C5.58286 5.25138 4.51754 6.38281 4.52049 8.55072L4.52149 8.86157L19.4696 8.84158V8.49175C19.4272 6.34283 18.349 5.21539 16.4138 5.04748L16.4148 5.81709C16.4148 6.24688 16.0801 6.58771 15.6556 6.58771C15.2212 6.58871 14.8944 6.24888 14.8944 5.81909L14.8934 5.0095Z"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
  <IconWrapper v-else name="calendar" :color="color" fillMode="stroke">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.09277 9.4043H20.9167"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4424 13.3105H16.4516"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0049 13.3105H12.0141"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.55762 13.3105H7.56688"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4424 17.1953H16.4516"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0049 17.1953H12.0141"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.55762 17.1953H7.56688"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M16.0439 2V5.29078" stroke="#1B1B1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M7.96582 2V5.29078" stroke="#1B1B1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.2383 3.58008H7.77096C4.83427 3.58008 3 5.21601 3 8.2231V17.2727C3 20.3271 4.83427 22.0009 7.77096 22.0009H16.229C19.175 22.0009 21 20.3555 21 17.3484V8.2231C21.0092 5.21601 19.1842 3.58008 16.2383 3.58008Z"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
  filled?: boolean
}>()
</script>
